import { render, staticRenderFns } from "./MyModal.vue?vue&type=template&id=095bdb00&scoped=true&"
import script from "./MyModal.vue?vue&type=script&lang=js&"
export * from "./MyModal.vue?vue&type=script&lang=js&"
import style0 from "./MyModal.vue?vue&type=style&index=0&id=095bdb00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095bdb00",
  null
  
)

export default component.exports